import Input from 'component/atom/forms/input/input/Input';
import TextArea from 'component/atom/forms/text-area/TextArea';
import Modal from 'component/hoc/modal/Modal';
import { useFormik } from 'formik';
import { workflowToast } from 'helpers/toastMessages';
import { workflow } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

const Form = ({ formik }) => {
  return (
    <form
      autoComplete="off"
      className="formCont"
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <Input
        label="Name"
        placeholder="Enter Name"
        name="name"
        value={formik.values.name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.name}
        touched={formik.touched.name}
      />
      <TextArea
        label="Description"
        placeholder="Enter Description"
        name="description"
        value={formik.values.description}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.description}
        touched={formik.touched.description}
      />
    </form>
  );
};
const NewWorkflow = ({ isOpen, onClose, selectedItems, setRefetch, id }) => {
  const navigate = useNavigate();
  const { mutate: postWorkflow, isPending } = usePost({
    onSuccessToast: selectedItems ? workflowToast.update : workflowToast.save,
    toastType: selectedItems ? 'update' : 'add',
  });
  const validationSchema = Yup.object({
    name: Yup.string().required('Name is Required'),
    description: Yup.string().required('Description is Required'),
  });
  const formik = useFormik({
    initialValues: {
      name: selectedItems?.name ?? '',
      description: selectedItems?.description ?? '',
      edges: selectedItems?.edges ?? [],
      nodes: selectedItems?.nodes ?? [],
      botId: id,
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      if (selectedItems?.id) {
        values.id = selectedItems?.id;
      }
      postWorkflow(
        {
          url: selectedItems ? workflow.update : workflow.createWorkflow,
          data: values,
          method: 'POST',
        },
        {
          onSuccess: (data) => {
            if (!selectedItems) navigate(`/workflow/${data?.data?.id}`);
            window.location.reload();
            resetForm();
            setRefetch((prev) => !prev);
            onClose();
          },
        }
      );
      onClose();
    },
    enableReinitialize: true,
  });
  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);
  return (
    <div>
      <Modal
        title={selectedItems?.id ? 'Update Workflow' : 'New Workflow'}
        isOpen={isOpen}
        onClose={onClose}
        modalContent={{
          component: <Form formik={formik} />,
        }}
        onSubmit={formik.handleSubmit}
        buttonType="submit"
        onSubmitstyles={{
          onSubmit: {
            label: selectedItems ? 'Update' : 'Create',
            opicBAckground: true,
          },
        }}
        isLoading={isPending}
      />
    </div>
  );
};
export default NewWorkflow;
